import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import { STRINGS } from "../Strings";
import PageHero from "./PageHero";

// Imports za picha zote juu ya faili kwa ulinganifu wa kurasa
import contactHeroBg from "../assets/orphans.jpg";
import officeBg from "../assets/youth.jpg";
import communicationBg from "../assets/prisoners.jpg";

import { FaMapMarkerAlt, FaEnvelopeOpen, FaGlobeAfrica, FaPhoneAlt, FaRegClock } from "react-icons/fa";

export default function ContactContent(props) {
    const appContext = useContext(AppContext);
    const language = appContext.language || "sw";
    const c = STRINGS.contactPage;

    const [ready, setReady] = useState(false);

    async function init() {
        setReady(false);
        // Initialization space if needed
        setReady(true);
    }

    useEffect(() => {
        init();
    }, []);

    if (ready) {
        return (
            <div className="contact-page-wrapper">
                {/* 1. Kuitisha PageHero mwanzoni mwa ukurasa */}
                <PageHero 
                    kicker={c.hero.kicker[language]} 
                    title={c.hero.title[language]} 
                    bgImage={contactHeroBg} 
                />

				{/* 3. Section 2: Channels & Numbers - Solid Color Style (surfaceColor) */}
                <section className="MainBodySection py-5 contact-surface-section">
                    <div className="container py-4">
                        <div className="text-center mb-5">
                            <h2 className="title-font-bold cnt-primary-text text-uppercase m-0">{c.channels.title[language]}</h2>
                            <div className="contact-primary-bar mx-auto mt-2"></div>
                        </div>

                        <div className="row g-4 justify-content-center">
                            {/* Phone Numbers Column */}
                            <div className="col-12 col-md-4 text-center">
                                <div className="contact-clean-profile p-3">
                                    <FaPhoneAlt size={26} className="cnt-primary-text mb-3" />
                                    <h5 className="title-font-semi-bold text-darkColor mb-1">{c.channels.phoneTitle[language]}</h5>
                                    <p className="font-regular text-muted small mb-0">{c.channels.phoneDesc[language]}</p>
                                </div>
                            </div>

                            {/* Email Address Column */}
                            <div className="col-12 col-md-4 text-center">
                                <div className="contact-clean-profile p-3">
                                    <FaEnvelopeOpen size={26} className="cnt-primary-text mb-3" />
                                    <h5 className="title-font-semi-bold text-darkColor mb-1">{c.channels.emailTitle[language]}</h5>
                                    <p className="font-regular text-muted small mb-0">{c.channels.emailDesc[language]}</p>
                                </div>
                            </div>

                            {/* Office Hours Column */}
                            <div className="col-12 col-md-4 text-center">
                                <div className="contact-clean-profile p-3">
                                    <FaRegClock size={26} className="cnt-primary-text mb-3" />
                                    <h5 className="title-font-semi-bold text-darkColor mb-1">{c.channels.hoursTitle[language]}</h5>
                                    <p className="font-regular text-muted small mb-0">{c.channels.hoursDesc[language]}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* 2. Section 1: Head Office Details - Image Background with Low Opacity Overlay */}
                <section className="contact-bg-section position-relative py-5" style={{ backgroundImage: `url(${officeBg})` }}>
                    <div className="contact-primary-overlay"></div>
                    <div className="container position-relative z-index-3 py-4">
                        <div className="text-center mb-5">
                            <h2 className="title-font-bold text-white text-uppercase m-0">{c.info.title[language]}</h2>
                            <div className="contact-center-bar mx-auto mt-2"></div>
                        </div>

                        <div className="row g-4 justify-content-center">
                            {/* Physical Address Card */}
                            <div className="col-12 col-md-4">
                                <div className="contact-translucent-box p-4 h-100 text-center text-md-start">
                                    <div className="contact-icon-wrapper mb-3 d-inline-flex align-items-center justify-content-center">
                                        <FaMapMarkerAlt size={22} />
                                    </div>
                                    <h4 className="title-font-semi-bold text-white mb-2">{c.info.addressTitle[language]}</h4>
                                    <p className="font-regular text-white-75 mb-0 small lh-base">{c.info.addressDesc[language]}</p>
                                </div>
                            </div>

                            {/* Postal Address Card */}
                            <div className="col-12 col-md-4">
                                <div className="contact-translucent-box p-4 h-100 text-center text-md-start">
                                    <div className="contact-icon-wrapper mb-3 d-inline-flex align-items-center justify-content-center">
                                        <FaEnvelopeOpen size={20} />
                                    </div>
                                    <h4 className="title-font-semi-bold text-white mb-2">{c.info.postalTitle[language]}</h4>
                                    <p className="font-regular text-white-75 mb-0 small lh-base">{c.info.postalDesc[language]}</p>
                                </div>
                            </div>

                            {/* Area of Operation Card */}
                            <div className="col-12 col-md-4">
                                <div className="contact-translucent-box p-4 h-100 text-center text-md-start">
                                    <div className="contact-icon-wrapper mb-3 d-inline-flex align-items-center justify-content-center">
                                        <FaGlobeAfrica size={22} />
                                    </div>
                                    <h4 className="title-font-semi-bold text-white mb-2">{c.info.operationTitle[language]}</h4>
                                    <p className="font-regular text-white-75 mb-0 small lh-base">{c.info.operationDesc[language]}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                

                {/* 4. Section 3: National Scope Highlight - Image Background with Dark Overlay */}
                {/* <section className="contact-bg-section position-relative py-5" style={{ backgroundImage: `url(${communicationBg})` }}>
                    <div className="contact-dark-overlay"></div>
                    <div className="container position-relative z-index-3 py-5 text-center">
                        <div className="row justify-content-center">
                            <div className="col-12 col-lg-8">
                                <span className="title-font-light text-uppercase tracking-widest text-white-75 small">KUKAJA NATIONWIDE</span>
                                <h3 className="title-font-semi-bold text-white mt-2 mb-0 lh-base">
                                    {language === "sw" 
                                        ? "Tunafanya kazi Tanzania nzima kwa ajili ya kulinda, kutunza na kuthamini utu wa kila mtu katika jamii yetu."
                                        : "We operate on a national scale across the entire country to care for, protect, and value the dignity of every person in the community."
                                    }
                                </h3>
                            </div>
                        </div>
                    </div>
                </section> */}
            </div>
        );
    } else {
        return (
            <div className="container mSupportLoading d-flex justify-content-center align-items-center" style={{ height: "200px" }}>
                {getInlineLoader()}
            </div>
        );
    }
}